module.exports = __webpack_public_path__ + "static/09-528b80eef721ab248f39992632f38b57.png";